import React from 'react';

import { Typography } from '@mui/material';

import { chatActiveTab, ClientChatTypes } from '@pharmaplan/common';
import { useAppSelector } from '../../../hooks/useAppSelector';
import strings from '../../../localization';

import styles from './styles';

const { pharmacist, pharmacy, technician, student } = ClientChatTypes;

const GroupListMiddleHeader = () => {
  const activeTab = useAppSelector(chatActiveTab);

  const titleConfig = {
    [pharmacist]: strings.pharmacistList,
    [student]: strings.pharmacyStudentsList,
    [technician]: strings.techniciansList,
    [pharmacy]: strings.pharmacyList,
  };

  return (
    <Typography sx={styles.title}>
      {titleConfig?.[activeTab as keyof typeof titleConfig]}
    </Typography>
  );
};

export default GroupListMiddleHeader;
